/** @format */

import {styled, Box} from '@mui/material';

export const ProgressBarContainer = styled(Box)(({theme}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '20px',
  marginTop: theme.spacing(0.5),
}));

export const CenterLine = styled(Box)({
  position: 'absolute',
  left: '50%',
  top: '-1px',
  bottom: '-1px',
  width: '1px',
  backgroundColor: '#fff',
  transform: 'translateX(-50%)',
  zIndex: 2,
});

export const BarWrapper = styled(Box)({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

interface BarProps {
  isPositive: boolean;
  percentage: number;
  backgroundColor?: string;
}

export const Bar = styled(Box, {
  shouldForwardProp: prop =>
    prop !== 'isPositive' &&
    prop !== 'percentage' &&
    prop !== 'backgroundColor'
})<BarProps>(({theme, isPositive, percentage, backgroundColor}) => ({
  position: 'absolute',
  [isPositive ? 'left' : 'right']: '50%',
  width: `${Math.min(percentage / 2, 50)}%`,
  height: '100%',
  backgroundColor,
  borderRadius: isPositive ? theme.spacing(0, 1, 1, 0) : theme.spacing(1, 0, 0, 1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: isPositive ? 'flex-start' : 'flex-end',
  zIndex: 1,
}));

export const DifferenceText = styled(Box)(({theme}) => ({
  fontSize: '12px',
  lineHeight: '14px',
  color: theme.palette.semantic_dark?.bad?.on,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  padding: theme.spacing(0.5),
}));
